<form *ngIf="!isSaved" [formGroup]="subjectForm" class="subject-management-create-subject-form">
  <div class="subject-management-create-subject-grid">
    <div
      class="subject-management-create-field subject-management-create-field-sm subject-management-create-field-term">
      <app-select label="เทอมการศึกษา" formControlName="academicTerm" [required]="true"
        [options]="academicTermOptions" [searchable]="false" [clearable]="true" [isDisabled]="true"
        [error]="hasSubjectError('academicTerm')" errorMessage="กรุณากรอกข้อมูล"
        inputClass="subject-management-create-select" classes="mb-0"></app-select>
    </div>

    <div
      class="subject-management-create-field subject-management-create-field-sm subject-management-create-field-year">
      <app-select label="ปีการศึกษา" formControlName="year" [required]="true" [options]="yearOptions"
        [searchable]="false" [clearable]="true" [isDisabled]="true" [error]="hasSubjectError('year')"
        errorMessage="กรุณากรอกข้อมูล" inputClass="subject-management-create-select" classes="mb-0"></app-select>
    </div>

    <div
      class="subject-management-create-field subject-management-create-field-sm subject-management-create-field-type">
      <app-select label="ประเภทรายวิชา" formControlName="subjectType" [required]="true"
        [clearable]="true"
        [options]="subjectTypeOptions" bindLabel="label" bindValue="id" [searchable]="false" 
        [isDisabled]="isSaved" [error]="hasSubjectError('subjectType')" errorMessage="กรุณากรอกข้อมูล"
        inputClass="subject-management-create-select" classes="mb-0"></app-select>
    </div>

    <div
      class="subject-management-create-field subject-management-create-field-sm subject-management-create-field-code">
      <app-select label="รหัสวิชา" formControlName="subjectCode" [required]="true" [options]="subjectOptions"
        bindLabel="code" optionBindLabel="displayLabel" bindValue="id" [searchable]="true" [clearable]="true" [isDisabled]="isSubjectCodeDisabled()"
        [error]="hasSubjectError('subjectCode')" errorMessage="กรุณากรอกข้อมูล"
        inputClass="subject-management-create-select" classes="mb-0"></app-select>
    </div>

    <div class="subject-management-create-field subject-management-create-field-name">
      <label class="subject-management-create-label" for="subject-name">
        ชื่อรายวิชา <span aria-hidden="true">*</span>
      </label>
      <!-- ชื่อรายวิชา is master-sourced and read-only in จัดการรายวิชา; edit it in
           Settings → รายวิชา. The offering never mutates the master subject. -->
      <input id="subject-name" type="text" class="form-control subject-management-create-input"
        formControlName="subjectName" readonly />
    </div>

    <div class="subject-management-create-field subject-management-create-field-curriculum">
      <app-select label="หลักสูตร" formControlName="curriculumTypeId" [required]="true"
        [options]="curriculumTypeOptions" bindLabel="name" bindValue="id" [searchable]="true" [clearable]="true"
        [error]="hasSubjectError('curriculumTypeId')" errorMessage="กรุณาเลือกหลักสูตร"
        inputClass="subject-management-create-select" classes="mb-0"></app-select>
    </div>

    <div
      class="subject-management-create-field subject-management-create-field-sm subject-management-create-field-credit">
      <label class="subject-management-create-label" for="subject-credit-description">
        คำอธิบายหน่วยกิต <span aria-hidden="true">*</span>
      </label>
      <input id="subject-credit-description" type="text" class="form-control subject-management-create-input"
        formControlName="creditDescription" />
      @if (hasSubjectError('creditDescription')) {
        <span class="error text-danger">{{ getCreditDescriptionErrorMessage() }}</span>
      }
    </div>
  </div>

  <div class="subject-management-create-actions" *ngIf="!isSaved">
    <button type="button" class="app-button app-button-primary subject-management-create-save-button"
      (click)="requestSave.emit()">
      บันทึก
    </button>
  </div>
</form>

<div *ngIf="isSaved" class="subject-management-create-subject-preview">
  <div class="subject-management-create-preview-actions">
    <button *ngIf="allowDelete && !subjectApprovalStatusLabel" type="button"
      class="app-button app-button-primary subject-management-create-delete-subject-button"
      (click)="requestDelete.emit()">
      <img src="assets/media/icons/svg/trush.svg" alt="" aria-hidden="true" />
      <span>ลบรายวิชา</span>
    </button>
    <app-subject-management-status-badge
      *ngIf="subjectApprovalStatusLabel"
      [label]="subjectApprovalStatusLabel"
      [status]="subjectApprovalStatus"
      size="subject"
    ></app-subject-management-status-badge>
  </div>

  <div class="subject-management-create-preview-grid">
    <div class="subject-management-create-preview-item subject-management-create-preview-item-short">
      <span class="subject-management-create-preview-label">เทอมการศึกษา :</span>
      <span class="subject-management-create-preview-value">{{ getSubjectPreviewValue('academicTerm') }}</span>
    </div>
    <div class="subject-management-create-preview-item subject-management-create-preview-item-short">
      <span class="subject-management-create-preview-label">ปีการศึกษา :</span>
      <span class="subject-management-create-preview-value">{{ getSubjectPreviewValue('year') }}</span>
    </div>
     <div class="subject-management-create-preview-item subject-management-create-preview-item-short">
      <span class="subject-management-create-preview-label">รหัสวิชา :</span>
      <span class="subject-management-create-preview-value">{{ getSubjectPreviewValue('subjectCode') }}</span>
    </div>
    <div class="subject-management-create-preview-item subject-management-create-preview-item-medium">
      <span class="subject-management-create-preview-label">ประเภทรายวิชา :</span>
      <span class="subject-management-create-preview-value">{{ getSubjectPreviewValue('subjectType') }}</span>
    </div>
   
    <div class="subject-management-create-preview-item subject-management-create-preview-item-long">
      <span class="subject-management-create-preview-label">ชื่อรายวิชา :</span>
      <span class="subject-management-create-preview-value">{{ getSubjectPreviewValue('subjectName') }}</span>
    </div>
    <div class="subject-management-create-preview-item subject-management-create-preview-item-long">
      <span class="subject-management-create-preview-label">หลักสูตร :</span>
      <span class="subject-management-create-preview-value">{{ getSubjectPreviewValue('curriculum') }}</span>
    </div>
    <div class="subject-management-create-preview-item subject-management-create-preview-item-long subject-management-create-preview-item-wide">
      <span class="subject-management-create-preview-label">คำอธิบายหน่วยกิต :</span>
      <span class="subject-management-create-preview-value">{{ getSubjectPreviewValue('creditDescription') }}</span>
    </div>
  </div>
</div>
